module.exports = __webpack_public_path__ + "static/media/gq.12d5546c.svg";